import { hot } from 'react-hot-loader/root';
import React from 'react';
import ReactDOM from 'react-dom';
import { unregister } from './registerServiceWorker';
import App from './components/App';

// just make sure there's no service-worker.
// we don't need offline mode or anything,
// so regular browser caching is fine
unregister();

const TheApp = hot(App);
ReactDOM.render(<TheApp />, document.getElementById('root'));
